import * as yup from 'yup'

const validate = yup.object().shape({
  email: yup.string().required(),
  password: yup.string().required(),
})

export default validate
